import rimraf from './index.js'

export = Object.assign(rimraf, { default: rimraf })
